export default () => {
  document.addEventListener('DOMContentLoaded', function () {
    window.dataLayer = window.dataLayer || [];

    function trackNavigationClick(format, layer, text, url) {
      window.dataLayer.push({
        'event': 'navigation_click',
        'navigation_format': format || 'desktop',
        'navigation_layer': String(layer),
        'click_text': text,
        'click_url': url
      });
    }

    function getFormat(element) {
      if (element.closest('.mobile-only') || element.closest('.navigation__mobile')) {
        return 'mobile';
      }
      return 'desktop';
    }

    function bindClickTracker(link, layer) {
      // Links inside the component library header are tracked by its own
      // data-layer--navigation controller.
      if (link.closest('[data-controller~="data-layer--navigation"]')) return;

      link.addEventListener('click', function () {
        var text = link.textContent.trim();
        var url = link.getAttribute('href');
        var format = getFormat(link);
        trackNavigationClick(format, layer, text, url);
      });
    }

    // Type 1: Header business sector buttons (layer 1)
    document.querySelectorAll('.header__business-sector-buttons a').forEach(function (link) {
      bindClickTracker(link, 1);
    });

    // Type 1b: Mobile business sector buttons inside .better-links (layer 1)
    document.querySelectorAll('.navigation__menu-item.better-links .navigation__sub-menu a').forEach(function (link) {
      bindClickTracker(link, 1);
    });

    // Type 2: Header navigation links
    document.querySelectorAll('.navigation__menu-item:not(.better-links):not(.navigation__search)').forEach(function (menuItem) {
      // Direct link in the menu item button (e.g. "Help Centre") - layer 1
      var directLink = menuItem.querySelector('.navigation__menu-item__link a');
      if (directLink) {
        bindClickTracker(directLink, 1);
      }

      // Sub-menu links - layer 2
      var subMenu = menuItem.querySelector('.navigation__sub-menu');
      if (subMenu) {
        subMenu.querySelectorAll('a').forEach(function (link) {
          if (!link.closest('.media-card')) {
            bindClickTracker(link, 2);
          }
        });
      }
    });

    // Type 3: Footer navigation links
    document.querySelectorAll('.footer__navigation__toplevel > a').forEach(function (link) {
      bindClickTracker(link, 1);
    });

    document.querySelectorAll('.footer__navigation__submenu a').forEach(function (link) {
      bindClickTracker(link, 2);
    });
  });
};
